import React from 'react';
import {TypesUtils} from "./TypesUtils";

const getDataByUsage = (usage, data) => {
  if (!usage) {
    return;
  }
  if (usage.general === false) {
    data = null;
    return;
  }
  for (const property in data) {
    if (data.hasOwnProperty(property)) {
      if (TypesUtils.isObject(data[property])) {
        data[property] = getDataByUsage(usage[property], Object.assign({}, data[property]));
      } else {
        if (usage[property] === false) {
          delete data[property];
        }
      }
    }
  }
  return data;
};

export const FormUtils = {
  validators: {
    required: (fieldName) => value => value ? undefined : `${fieldName} is required`
  },
  renderField: ({input, label, name, placeholder, className, type, meta: {touched, error, warning}}) => (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <input className={className} {...input} placeholder={placeholder} type={type}/>
      {touched && ((error && <p className="alert alert-danger">{error}</p>) || (warning &&
        <p className="alert alert-warning">{warning}</p>))}
    </div>
  ),

  getValuesByUsage: (usage, data) => {
    return getDataByUsage(usage, Object.assign({}, data));
  },

  getNotEmptyValues: (formValues) => {
    const values = Object.assign({}, formValues);
    for (const property in values) {
      if (values.hasOwnProperty(property) && values[property] === "") {
        delete values[property];
      }
    }
    return values;
  }

};



// WEBPACK FOOTER //
// ./src/utils/FormUtils.js